module.exports = __webpack_public_path__ + "img/89.411b3f3a.jpg";